export function mergeStrings(str, delimiter) {
    if (delimiter === void 0) { delimiter = ' '; }
    var allValids = str.filter(Boolean);
    if (!allValids.length) {
        return undefined;
    }
    return allValids.join(delimiter);
}
/** makes nlNL => nl-NL and mnMongCN => mn-Mong-CN */
export function hyphenLocale(locale) {
    // ([a-z]+) = language (en)
    // ([A-Z][a-z]+)? = optional language type (Cyrl/Latn)
    // ([A-Z]*) = optional country code (GB)
    return locale
        .replace(/_/g, '-')
        .replace(/^([a-z]+)(?!-)([A-Z][a-z]+)?(?!-)([A-Z]+)?$/, function (match, p1, p2, p3) { return [p1, p2, p3].filter(Boolean).join('-'); });
}
//# sourceMappingURL=strings.js.map